exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog[data-v-7c516b3d]{border-radius:8px!important}.v-dialog .v-card__text[data-v-7c516b3d]{padding:0!important}.v-dialog .v-alert[data-v-7c516b3d]{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.v-dialog[data-v-7c516b3d],.v-dialog .v-card__text[data-v-7c516b3d]{overflow:hidden!important}.dialog-message[data-v-7c516b3d]{font-size:16px;font-weight:500;color:#696a71}", ""]);

// exports
